import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { getPushCapabilities } from "../../../services/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const usePushCapabilities = () => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;

  return useQuery({
    queryKey: pushNotificationKeys.capabilities(tenantCode),
    queryFn: ({ signal }) => getPushCapabilities({ signal }),
    enabled: Boolean(tenantCode),
    staleTime: 30_000,
  });
};

export default usePushCapabilities;
